import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/views/Login.vue') // 登录页
const Index = () => import('@/views/Index.vue') // 布局容器页
const Icon = () => import('@/views/Icon.vue') // 图标组页
const ShowImg = () => import('@/views/ShowImg.vue') // 预览图片
const Info = () => import('@/pages/info') // 首页

const CaseForm = () => import('@/components/CaseForm.vue')

// 案件
const Allcase = () => import('@/pages/case/Allcase.vue') // 全部案件
const AddCase = () => import('@/pages/case/AddCase.vue') // 新增案件
const TodoCase = () => import('@/pages/case/TodoCase.vue') // 待办案件列表页
const TodoYGCase = () => import('@/pages/case/TodoYGCase.vue') // 业管待办案件列表页
const OvertimeCase = () => import('@/pages/case/OvertimeCase.vue') // 超期案件

// 报表
const Report = () => import('@/pages/report/Report.vue') // 系统报表
const ExportReport = () => import('@/pages/report/ExportReport.vue') // 导出报表

// 邮件
const SendEmail = () => import('@/pages/email/SendEmail.vue') // 发送邮件通知
const MyEmail = () => import('@/pages/email/MyEmail.vue') // 定时邮件列表

const CaseDetailV2 = () => import('@/pages/caseDetailV2') // 案件详情-编辑修改
const Disease = () => import('@/pages/disease') // 疾病库列表页
const ReviewDisposeCase = () => import('@/pages/reviewDisposeCase') // 审核处理件数统计
const ManagementFunction = () => import('@/pages/managementFunction') // 业管功能
const SendEmailOne = () => import('@/pages/sendEmailOne') // 一键发送邮件

// 任务列表
const Task = () => import('@/pages/task/Task.vue') // 全部任务列表页
const MyTask = () => import('@/pages/task/MyTask.vue') // 我的任务列表页
const MyResearchTask = () => import('@/pages/task/myResearchTask.vue') // 我的调查任务列表页

// 废弃的页面
const CaseDetail = () => import('@/pages/caseDetail/CaseDetail.vue') // 案件详情-编辑修改（已弃用）
const CaseMoreInfo = () => import('@/pages/caseDetail/CaseMoreInfo.vue') // 补充材料（已弃用）
const ChangeCaseInfo = () => import('@/pages/caseDetail/ChangeCaseInfo.vue') // 变更受助人信息（已弃用）

// 流程管理
const ProcessManage = () => import('@/pages/process/ProcessManage.vue') // 列表页
const AddProcessM = () => import('@/pages/process/AddProcessM.vue') // 新增页
const ReviseProcessM = () => import('@/pages/process/ReviseProcessM.vue') // 编辑修改页

// 菜单管理
const Menu = () => import('@/pages/menu/Menu.vue') // 列表页
const AddMenu = () => import('@/pages/menu/AddMenu.vue') // 新增页
const ReviseMenu = () => import('@/pages/menu/ReviseMenu.vue') // 编辑修改页

// 角色管理
const Role = () => import('@/pages/role/Role.vue') // 列表页
const AddRole = () => import('@/pages/role/AddRole.vue') // 新增页
const ReviseRole = () => import('@/pages/role/ReviseRole.vue') // 编辑修改页

// 管理员管理
const User = () => import('@/pages/user/User.vue') // 列表页
const AddUser = () => import('@/pages/user/AddUser.vue') // 新增页
const ReviseUser = () => import('@/pages/user/ReviseUser.vue') // 编辑修改页

// 部门管理
const Dept = () => import('@/pages/dept/Dept.vue') // 列表页
const AddDept = () => import('@/pages/dept/AddDept.vue') // 新增页
const ReviseDept = () => import('@/pages/dept/ReviseDept.vue') // 编辑修改页

// 定时任务
const Schedule = () => import('@/pages/schedule/Schedule.vue') // 列表页
const AddSchedule = () => import('@/pages/schedule/AddSchedule.vue') // 新增页
const ReviseSchedule = () => import('@/pages/schedule/ReviseSchedule.vue') // 编辑修改页
const ScheduleLog = () => import('@/pages/schedule/ScheduleLog.vue') // 日志列表

// 字典管理
const Dict = () => import('@/pages/dict/Dict.vue') // 列表页
const AddDict = () => import('@/pages/dict/AddDict.vue') // 新增页
const ReviseDict = () => import('@/pages/dict/ReviseDict.vue') // 编辑修改页

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      redirect: '/',
      hidden: true
    },
    {
      path: '/caseform',
      component: CaseForm
    },
    {
      path: '/icon',
      component: Icon
    },
    {
      path: '/showImg',
      component: ShowImg
    },
    {
      path: '/index',
      component: Index,
      children: [
        {
          path: '',
          redirect: 'info',
          hidden: true
        },
        {
          path: 'info',
          component: Info
        },
        {
          path: 'allcase',
          component: Allcase
        },
        {
          path: 'addcase',
          component: AddCase
        },
        {
          path: 'overtimeCase',
          component: OvertimeCase
        },
        {
          path: 'casedetail/:caseCode',
          component: CaseDetail,
          children: [
            {
              path: '/',
              component: CaseForm
            }
          ]
        },
        {
          path: 'CaseDetailV2/:caseCode',
          component: CaseDetailV2,
          children: [
            {
              path: '/',
              component: CaseForm
            }
          ]
        },
        {
          path: 'changecase/:caseCode',
          component: ChangeCaseInfo
        },
        {
          path: 'moreinfo/:caseCode',
          component: CaseMoreInfo
        },
        {
          path: 'sendemail/:caseCode/:flowCode',
          component: SendEmail
        },
        {
          path: 'myemail',
          component: MyEmail,
          children: [
            {
              path: '/',
              component: CaseForm
            }
          ]
        },
        {
          path: 'report',
          component: Report
        },
        {
          path: 'exportReport',
          component: ExportReport
        },
        {
          path: 'processManage',
          component: ProcessManage
        },
        {
          path: 'addprocessM',
          component: AddProcessM
        },
        {
          path: 'reviseprocessM/:id',
          component: ReviseProcessM
        },
        {
          path: 'todoCase',
          component: TodoCase
        },
        {
          path: 'todoygCase',
          component: TodoYGCase
        },
        {
          path: 'task',
          component: Task
        },
        {
          path: 'mytask',
          component: MyTask
        },
        {
          path: 'myResearchTask',
          component: MyResearchTask
        },
        {
          path: 'disease',
          component: Disease
        },
        {
          path: 'user',
          component: User
        },
        {
          path: 'adduser',
          component: AddUser
        },
        {
          path: 'reviseuser/:id',
          component: ReviseUser
        },
        {
          path: 'dept',
          component: Dept
        },
        {
          path: 'adddept',
          component: AddDept
        },
        {
          path: 'revisedept/:id',
          component: ReviseDept
        },
        {
          path: 'role',
          component: Role
        },
        {
          path: 'addrole',
          component: AddRole
        },
        {
          path: 'reviserole/:id',
          component: ReviseRole
        },
        {
          path: 'menu',
          component: Menu
        },
        {
          path: 'addmenu',
          component: AddMenu
        },
        {
          path: 'revisemenu/:id',
          component: ReviseMenu
        },
        {
          path: 'dict',
          component: Dict
        },
        {
          path: 'adddict',
          component: AddDict
        },
        {
          path: 'revisedict/:id',
          component: ReviseDict
        },

        {
          path: 'schedule',
          component: Schedule
        },
        {
          path: 'addschedule',
          component: AddSchedule
        },
        {
          path: 'reviseschedule/:id',
          component: ReviseSchedule
        },

        {
          path: 'schedulelog',
          component: ScheduleLog
        },
        {
          path: 'reviewDisposeCase',
          component: ReviewDisposeCase
        },
        {
          path: 'managementFunction',
          component: ManagementFunction
        },
        {
          path: 'sendMailOne',
          component: SendEmailOne
        }
      ]
    }
  ]
})
